module.exports = __webpack_public_path__ + "static/media/Knob.182f6e46.jpg";